<template>
    <div class="animated fadeIn">
        <LoadingWidget v-if="initStatus != 1" :status="initStatus" @init="init" />
        <b-card v-else>
            <template v-slot:header>
                <h5>Edit Gadai</h5>
            </template>
            <div class="filter-form-wrapper mb-3">
                <b-row>
                    <b-col md="12" lg="6">
                        <b-form-group class="form-inline filter-form-date" label-for="filterDate" label="Tgl. Pengajuan">
                            <div class="d-flex align-items-center search-input-wrapper">
                                <b-form-input
                                    v-model="input.filterFromDate" name="filterFromDate"
                                    id="filterDate"
                                    type="date"
                                ></b-form-input>
                                <span class="ml-2 mr-2 d-flex align-items-center">s/d</span>
                                <b-form-input 
                                    v-model="input.filterToDate" name="filterToDate"
                                    type="date"
                                ></b-form-input>
                            </div>
                        </b-form-group>
                        <b-form-group class="form-inline" label-for="filterNoFaktur" label="No. Faktur">
                            <b-form-input
                                v-model="input.filterNoFaktur" name="filterNoFaktur"
                                type="search"
                                id="filterNoFaktur"
                                placeholder="Masukkan no. faktur"
                            ></b-form-input>
                        </b-form-group>
                    </b-col>
                    <b-col md="12" lg="6">
                        <b-form-group class="form-inline" label-for="filterCabang" label="Cabang">
                            <div label="Filter Cabang">
                            <multiselect
                                name="filterCabang"
                                v-model="input.filterCabang" 
                                :options="cabangOption" 
                                :internal-search="true"
                                :allow-empty="true"
                                deselect-label=""
                                select-label=""
                                label="name"
                                track-by="name"
                                placeholder="-- Pilih filter cabang --"
                            />
                        </div>
                        </b-form-group>
                        <b-form-group class="form-inline" label-for="filterStatus" label="Status">
                            <b-form-select v-model="input.filterStatus" id="filterStatus" name="status" :options="statusOption" value-field="id" text-field="name">
                                <template v-slot:first>
                                    <b-form-select-option :value="null" disabled>Status</b-form-select-option>
                                </template>
                            </b-form-select>
                        </b-form-group>
                    </b-col>
					<b-col cols="12">
                        <div class="filter-btn-wrapper">
                            <b-button class="mr-2" variant="pgiBtn" name="searchTableBtn" :disabled="isBusy" @click="onFilter"> 
                                Search 
                            </b-button>
                            <b-button variant="pgiBtn" name="resetTableBtn" :disabled="isBusy" @click="onReset">Reset</b-button>
                        </div>
                    </b-col>
                </b-row>
			</div>
            <b-table bordered hover show-empty
                :busy="isBusy" 
                :items="dataEditGadai" 
                :fields="fields"
                :no-local-sorting="false"
                responsive class="mb-3">
                <template v-slot:table-busy>
                    <div class="text-center text-danger my-2">
                        <b-spinner class="align-middle"></b-spinner>
                        <strong>  Loading data...</strong>
                    </div>
                </template>
                <template v-slot:empty>
                    Tidak ada data gadai untuk diubah.
                </template>
                <template v-slot:cell(noFaktur)="row">
                    <div>{{ row.item.noFaktur }}</div>
                    <div class="smallText text-muted">{{ row.item.cabang.name }}</div>
                </template>
                <template v-slot:cell(diajukanOleh)="row">
                    <div>{{ row.item.diajukanOleh }}</div>
                    <div class="smallText text-muted">{{$helper.changeDateFormat(row.item.tanggalPengajuan)}} {{$helper.changeDateFormatGetHour(row.item.tanggalPengajuan)}}</div>
                </template>
                <template v-slot:cell(status)="row">
                    <b-badge variant="warning" v-if="row.item.status == 'PENDING'">PENDING</b-badge>
                    <b-badge variant="success" v-else-if="row.item.status == 'APPROVED'">DISETUJUI</b-badge>
                    <b-badge variant="danger" v-else-if="row.item.status == 'REJECTED'">DITOLAK</b-badge>
                    <b-badge v-else>{{ row.item.status }}</b-badge>
                </template>
                <template v-slot:head(status)>
                    Status 
                    <i class="fa fa-question tooltip-trigger-btn ml-1" @click="$bvModal.show('modal-info-status')"/>
                </template>
                <template v-slot:cell(action)="row">
                    <div class="no-wrap">
                        <b-link :to="`${$route.path}/${row.item.id}`">
                            <b-button size="sm" class="table-button view" v-b-tooltip.hover title="Detail" name="kasMutasiDetailBtn">
                                <i class="fa fa-info"></i>
                            </b-button>
                        </b-link>
                    </div>
                </template>
            </b-table>

            <div class="pagination-wrapper d-flex align-items-center justify-content-between">
                <b-input-group prepend="Tampilkan" class="align-items-center tableShowItem">
                    <b-form-select v-model="input.show" id="showItems" @change="onLimitChange" :options="options">
                        <template v-slot:first>
                            <b-form-select-option :value="null" disabled />
                        </template>
                    </b-form-select>
                    <span class="ml-2">{{ totalViewText }}</span>
                </b-input-group>
                <b-pagination class="mb-0"
                    v-model="currentPage"
                    :total-rows="rows"
                    :per-page="perPage"
                    aria-controls="my-table"
                    @input="onPageChange"
                ></b-pagination>
            </div>
        </b-card>
        
        <b-modal id="modal-info-status" title="Info Status" no-close-on-backdrop>
            <div class="detail-data-wrapper mb-3">
                <h6 class="form-title mb-1">PENDING</h6>
                <p class="smallText mb-0">Perubahan data gadai belum diproses.</p>
            </div>
            <div class="detail-data-wrapper mb-3">
                <h6 class="form-title mb-1">APPROVED</h6>
                <p class="smallText mb-0">Perubahan data gadai disetujui. Data gadai telah diubah sesuai dengan revisi yang diajukan.</p>
            </div>
            <div class="detail-data-wrapper mb-0">
                <h6 class="form-title mb-1">REJECTED</h6>
                <p class="smallText mb-0">Perubahan data gadai ditolak. Revisi digugurkan, dan data gadai tidak berubah.</p>
            </div>
            <template v-slot:modal-footer="{ cancel }">
                <b-button variant="secondary" name="closeDetailBtn" @click="cancel()">
                    Tutup
                </b-button>
            </template>
        </b-modal>
    </div>
</template>

<script>
export default {
    name: 'approval-edit-gadai',
    data(){
        return{
            initStatus: 0,
            isBusy: true,
            input:{
                show: 10,
                filterNoFaktur: null,
                filterCabang: null,
                filterStatus: null,
                filterFromDate: null,
                filterToDate: null,
                sortBy: null,
                sortDesc: null
            },
            fields: [
                { key: "noFaktur", label: "No. Faktur & Cabang" },
                { key: "nomorRevisi", label: "Revisi Ke-" },
                { key: "jenisBarang.name", label: "Jenis Barang" },
                { key: "diajukanOleh", label: "Diajukan Oleh/Pada" },
                { key: "status", label: "Status" },
                { key: "action", label: "Aksi" },
            ],
            options: [
                { value: 10, text: '10'},
                { value: 20, text: '20'},
                { value: 30, text: '30'},
                { value: 40, text: '40'},
                { value: 50, text: '50'},
            ],
            statusOption: [ 
                { id: '0', name: 'PENDING' },
                { id: '1', name: 'DISETUJUI' },
                { id: '2', name: 'DITOLAK' }
            ],
            cabangOption: [],
            dataEditGadai: [],
            currentPage: 1,
            perPage: 10,
            rows: null,
            totalViewText: "",
            page: '',
            size: '',
            loading: false,
            query: ""
        }
    }, 
    methods: {
        
        //----------------- Fungsi Inisialisasi -----------------

        init(){
            this.initStatus = 0
            this.page = 0
            this.size = this.input.show
            this.query = this.$helper.makeQuery(this.page, this.size)
            this.cabangOption = this.$helper.getAllCabang()

            let getApprovalEditGadai= this.$axios.get("approval-edit-gadai/"+this.query).then(response => {
                this.dataEditGadai = response.data.data
                this.updateTotalItem(response.data.total)
                let msg = this.$helper.getFlash()
                this.$helper.toastSucc(this, msg)
            })

            Promise.all([getApprovalEditGadai]).then(() => {
                this.initStatus = 1
                this.toggleBusy()
            })
            .catch(error => {
                console.log(error)
                this.initStatus = -1
            })

        },


        //----------------- Fungsi Ambil Data Cek Gadai -----------------

        getApprovalEditGadai(){
            this.toggleBusy()
            this.dataEditGadai = []

            if (this.input.filterCabang != null) this.query = this.query + "&filterCabang=" + this.input.filterCabang.id
            if (this.input.filterNoFaktur != null) this.query = this.query + "&filterNoFaktur=" + this.input.filterNoFaktur
            if (this.input.filterStatus != null) this.query = this.query + "&filterStatus=" + this.input.filterStatus
            if (this.$helper.isNotNullAndNotEmpty(this.input.filterFromDate)) this.query = this.query + "&filterStartDate=" + this.input.filterFromDate
            if (this.$helper.isNotNullAndNotEmpty(this.input.filterToDate)) this.query = this.query + "&filterEndDate=" + this.input.filterToDate
            if (this.input.sortBy != null) this.query = this.query + "&sortBy=" + this.input.sortBy
            if (this.input.sortDesc != null) this.query = this.query + "&sortDesc=" + this.input.sortDesc
            
            this.$axios.get("approval-edit-gadai/"+this.query).then(response => {
                this.dataEditGadai = response.data.data
                this.toggleBusy()
                this.updateTotalItem(response.data.total)
                this.loading = false
            })
            .catch(error => {
                console.log(error)
                console.log(error.response.data.reason)
                this.$helper.parseError(this, error)
                this.toggleBusy()
                this.loading = false
            })
        },

        //----------------- Fungsi Pagination, Sorting, dan loading -----------------
        
        onLimitChange(){
            this.size = this.input.show
            this.perPage = this.input.show
            this.currentPage = 1
            this.page = 0
            this.query = this.$helper.makeQuery(0, this.size)
            this.getApprovalEditGadai()
        },

        onPageChange(){
            if (this.loading == false) {
                this.page = this.currentPage - 1
                this.query = this.$helper.makeQuery(this.page, this.size)
                this.getApprovalEditGadai()
            }
        },

        onReset(){
            this.input.filterNoFaktur = null
            this.input.filterCabang = null
            this.input.filterStatus = null
            this.input.filterFromDate = null
            this.input.filterToDate = null
            this.currentPage = 1
            this.page = 0
            this.query = this.$helper.makeQuery(0, this.size)
            this.loading = true
            this.getApprovalEditGadai()
        },

        onFilter(){
            this.page = 0
            this.currentPage = 1
            this.query = this.$helper.makeQuery(0, this.size)
            this.loading = true
            this.getApprovalEditGadai()
        },


        //----------------- Fungsi Pindah Halaman dan Fungsi Lain -----------------

        toggleBusy() {
            if(this.isBusy == true) this.isBusy = false
            else this.isBusy = true
        },

        updateTotalItem(total){
            let limit = null
            let prevLimit = null
            this.perPage = this.size
            this.rows = total
            prevLimit = this.page * this.size + 1
            limit = this.page * this.size + this.size
            if (limit > this.rows) limit = this.rows
            this.totalViewText = "Menampilkan "+ prevLimit + " - " + limit + " dari " + this.rows + " entri"
        }
    },

    created(){
        this.init()
    }
}
</script>
